import { createSlice } from '@reduxjs/toolkit'

export const GetPesticides = createSlice({
  name: 'Pesticide',
  initialState: {
    fetching: false,
    pesticides: [],
    error: null,

    isFilterEnabled: false,
    filteredPesticide: [],
    filterFetching: false,
    filterError: null,
  },
  reducers: {
    getPesticidesRequest: (state) => ({
      ...state, fetching: true, error: null, isFilterEnabled: false,
    }),
    getPesticidesSuccess: (state, { payload }) => ({
      ...state, fetching: false, pesticides: payload, error: null, isFilterEnabled: false,
    }),
    getPesticidesFailed: (state, { payload }) => ({
      ...state, fetching: false, error: payload, isFilterEnabled: false,
    }),

    resetFilter: (state) => ({
      ...state, filterFetching: false, filteredPesticide: [], filterError: null, isFilterEnabled: false,
    }),
    getPesticideFilterRequest: (state) => ({
      ...state, filterFetching: true, filteredPesticide: [], filterError: null, isFilterEnabled: false,
    }),
    getPesticideFilterSuccess: (state, { payload }) => ({
      ...state, filterFetching: false, filteredPesticide: payload, filterError: null, isFilterEnabled: true,
    }),
    getPesticideFilterFailed: (state, { payload }) => ({
      ...state, filterFetching: false, filteredPesticide: [], filterError: payload, isFilterEnabled: false,
    }),
  },
})

export const {
  getPesticidesRequest, getPesticidesSuccess, getPesticidesFailed,
  getPesticideFilterFailed, getPesticideFilterSuccess, getPesticideFilterRequest,
  resetFilter,
} = GetPesticides.actions
export default GetPesticides.reducer
